import React from 'react';
import { Link } from 'react-router-dom';
import Seo from '../../components/Seo';
import ITTrainingHeader from '../../components/ITTrainingHeader';
import ITTrainingFooter from '../../components/ITTrainingFooter';
import { programmingCourses } from '../../data/courseData';

function ProgrammingCourses() {
  return (
    <div className="itp-shell">
      <Seo
        title="Programming Courses | Python, Java, PHP, Android Training | Vedanskrix"
        description="Enroll in programming courses at Vedanskrix Ahmedabad. Learn Python, Java, PHP, Android, iOS, IoT with job placement assistance."
        keywords={['programming courses Ahmedabad','Python training','Java training','PHP training','Android development course','iOS training','IoT course','machine learning training','best programming institute','coding classes Gujarat']}
      />
      <ITTrainingHeader />

      {/* Hero Banner */}
      <section className="itpage-hero itpage-hero--prog">
        <div className="itpage-hero__overlay" />
        <div className="itp-container itpage-hero__content">
          <p className="itpage-hero__eyebrow">Vedanskrix IT Training</p>
          <h1 className="itpage-hero__title">Programming Courses</h1>
          <p className="itpage-hero__sub">Industry-aligned training with hands-on projects and job placement support</p>
          <div className="itpage-hero__crumb">
            <Link to="/it-training">Home</Link>
            <span> › </span>
            <span>Programming Courses</span>
          </div>
        </div>
      </section>

      {/* Course Grid */}
      <section className="itpage-section">
        <div className="itp-container">
          <div className="itpage-section-head">
            <span className="itpage-section-tag">{programmingCourses.length} Courses Available</span>
            <h2 className="itpage-section-title">Choose Your Programming Path</h2>
            <p className="itpage-section-sub">
              All courses include live project training, certificate of completion, and dedicated placement assistance.
            </p>
          </div>
          <div className="itpage-courses-grid">
            {programmingCourses.map((c) => (
              <div key={c.slug} className="itpage-course-card">
                <div className="itpage-course-card__icon">{c.icon}</div>
                <h3 className="itpage-course-card__title">{c.title}</h3>
                <p className="itpage-course-card__desc">{c.desc}</p>
                <div className="itpage-course-card__meta">
                  <span className="itpage-course-card__badge itpage-course-card__badge--duration">⏱ {c.duration}</span>
                  <span className="itpage-course-card__badge itpage-course-card__badge--level">🎯 {c.level}</span>
                </div>
                <div className="itpage-course-card__actions">
                  <Link to={`/it-training/course/${c.slug}`} className="itpage-course-card__btn">View Course →</Link>
                  <Link to="/it-training/contact" className="itpage-course-card__btn itpage-course-card__btn--outline">Enquire</Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Strip */}
      <section className="itpage-cta-strip">
        <div className="itp-container itpage-cta-strip__inner">
          <div>
            <h3 className="itpage-cta-strip__title">Not sure which course to pick?</h3>
            <p className="itpage-cta-strip__sub">Our counsellors will guide you to the right technology for your career goals.</p>
          </div>
          <Link to="/it-training/contact" className="itpage-cta-strip__btn">Free Counselling →</Link>
        </div>
      </section>

      <ITTrainingFooter />
    </div>
  );
}

export default ProgrammingCourses;
